import React from'react';
import Button from'../components/ui/Button';

interface ProblemSectionProps {}

const ProblemSection = ({}: ProblemSectionProps) => {
  return (
    <section id="problem" className="w-full bg-white py-8 xs:py-12 sm:py-16 lg:py-20">
      <div className="w-full max-w-[1200px] mx-auto px-3 xs:px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6 xs:gap-8 sm:gap-10 lg:gap-12 w-full">
          {/* Header */}
          <div className="flex flex-col items-center gap-3 xs:gap-4 w-full px-2 xs:px-0">
            <Button
              text="TRADITIONAL ESCROW VS AVERPACT"
              text_font_size="14"
              text_font_family="DM Sans"
              text_font_weight="600"
              text_line_height="18px"
              text_text_align="center"
              text_text_transform="uppercase"
              fill_background="linear-gradient(180deg,#FF3333 0%, #FF3333 100%)"
              border_border_radius="6px"
              effect_box_shadow="0px 4px 16px rgba(72,28,0,0.25)"
              padding="6px 12px"
              className="w-auto text-[10px] xs:text-xs sm:text-sm text-white"
            />
            
            <h2 className="text-[24px] sm:text-[32px] md:text-[40px] font-semibold leading-snug text-center text-[#141A23] font-poly max-w-4xl px-3 xs:px-4">
              How AverPact Works
            </h2>
          </div>

          {/* Comparison Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 w-full max-w-4xl">
            {/* Traditional Bank Escrow */}
            <div className="flex flex-col gap-4 p-5 sm:p-6 bg-white rounded-xl border-2 border-red-200">
              <h3 className="text-lg sm:text-xl font-semibold text-[#141A23] font-poly">
                Traditional Bank Escrow
              </h3>
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2">
                  <span className="text-red-500 font-bold mt-0.5 flex-shrink-0">x</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">1-3% fees + $5K-$50K setup costs</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-red-500 font-bold mt-0.5 flex-shrink-0">x</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Weeks to establish escrow account</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-red-500 font-bold mt-0.5 flex-shrink-0">x</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Manual release - slow, error-prone</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-red-500 font-bold mt-0.5 flex-shrink-0">x</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Opaque process - single point of failure</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-red-500 font-bold mt-0.5 flex-shrink-0">x</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Requires trusted intermediary (bank)</p>
                </div>
              </div>
            </div>

            {/* AverPact Smart Contract */}
            <div className="flex flex-col gap-4 p-5 sm:p-6 bg-white rounded-xl border-2 border-green-200">
              <h3 className="text-lg sm:text-xl font-semibold text-[#141A23] font-poly">
                AverPact Smart Contract
              </h3>
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-2">
                  <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">&lt; 1% fees + minimal gas costs</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Minutes to deploy and activate</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Automatic release on dual approval</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Full transparency - on-chain audit trail</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span>
                  <p className="text-sm sm:text-base text-[#141A237f] font-dm">Non-custodial, trustless, multi-chain</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tagline */}
          <p className="text-base sm:text-lg md:text-xl font-medium text-center text-[#141A23] font-dm max-w-3xl px-4">
            No intermediaries. No delays. No trust required - just verified agreements.
          </p>
        </div>
      </div>
    </section>
  )
}

export default ProblemSection
